module.exports = __webpack_public_path__ + "static/media/shapes.81cbad46.jpg";